export default __webpack_public_path__ + "static/media/accounting-bot_kr.47dab47f.png";